import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { ckAPIMethods } from 'chat-kit'
import ckModuleInit from "ck-dialog-language";
import moduleConfig from "./ckModuleConfigs/ckDLConfig";
const ckModule = ckModuleInit(moduleConfig);
ckAPIMethods.modules("initModule", ckModule);
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


serviceWorker.unregister();
